import { createComponent } from '../lib';
import { VmMenuRadioGroup } from '@vime/core';
import { define } from '../lib';
define('vm-menu-radio-group', VmMenuRadioGroup);
;
export default createComponent('vm-menu-radio-group', new Set(['value']));
